import React from 'react';
import Header from './Header';
import Footer from './Footer';

const EffervescentTablets = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
            /* Fix for bullets overflowing table columns */
            .table td, .table th {
                word-break: break-word;
                white-space: normal;
                vertical-align: top;
            }
            .table ul {
                padding-left: 1.2em;
                margin-bottom: 0;
            }
            .table li {
                word-break: break-word;
                white-space: normal;
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Effervescent <span class="underliner nocolor viewport-detect" data-delay="1000">Tablets</span></h2>
                            <p>Discover our range of effervescent tablets for optimal health and wellness</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Effervescent Tablets</h2>
                                    <p>Comprehensive range of effervescent tablets for various health needs</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- VITAMIN & MINERAL EFFERVESCENT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#vitaminEffervescent">
                                                    <i class="bi bi-capsule me-2"></i>VITAMIN & MINERAL EFFERVESCENT
                                                </button>
                                            </h2>
                                            <div id="vitaminEffervescent" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>INGREDIENTS</th>
                                                                    <th>NUTRITIONAL FACTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Vitamin C + Zinc Effervescent</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Vitamin C (Ascorbic Acid) – 1000 mg</li>
                                                                            <li>Zinc (Zinc Gluconate) – 10 mg</li>
                                                                            <li>Citric Acid – 500 mg</li>
                                                                            <li>Sodium Bicarbonate – 400 mg</li>
                                                                            <li>Natural Orange Flavor – 50 mg</li>
                                                                            <li>Sucralose – 15 mg</li>
                                                                            <li>Stevia – 10 mg</li>
                                                                            <li>Color (Beta-Carotene) – as needed</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 3.5 kcal</li>
                                                                            <li>Carbohydrates: 0.2 g</li>
                                                                            <li>Sugar: 0 g</li>
                                                                            <li>Sodium: 150 mg</li>
                                                                            <li>Vitamin C: 1000 mg (1250% RDA)</li>
                                                                            <li>Zinc: 10 mg (91% RDA)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Multivitamin + Electrolyte Effervescent</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Vitamin A – 600 mcg</li>
                                                                            <li>Vitamin C – 1000 mg</li>
                                                                            <li>Vitamin D3 – 800 IU (20 mcg)</li>
                                                                            <li>Vitamin E – 10 mg</li>
                                                                            <li>Vitamin B1 – 1.1 mg</li>
                                                                            <li>Vitamin B2 – 1.2 mg</li>
                                                                            <li>Vitamin B6 – 1.5 mg</li>
                                                                            <li>Vitamin B12 – 2.5 mcg</li>
                                                                            <li>Folic Acid – 200 mcg</li>
                                                                            <li>Niacin – 8 mg</li>
                                                                            <li>Potassium Chloride – 250 mg</li>
                                                                            <li>Sodium Chloride – 200 mg</li>
                                                                            <li>Magnesium Citrate – 100 mg</li>
                                                                            <li>Citric Acid, Sodium Bicarbonate, Sucralose, Natural Flavor</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 4.2 kcal</li>
                                                                            <li>Carbohydrates: 0.3 g</li>
                                                                            <li>Sugar: 0 g</li>
                                                                            <li>Sodium: 200 mg</li>
                                                                            <li>Potassium: 250 mg</li>
                                                                            <li>Magnesium: 100 mg</li>
                                                                            <li>Multivitamins: 100–150% RDA (avg)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- IMMUNITY & ENERGY EFFERVESCENT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#immunityEffervescent">
                                                    <i class="bi bi-capsule me-2"></i>IMMUNITY & ENERGY EFFERVESCENT
                                                </button>
                                            </h2>
                                            <div id="immunityEffervescent" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>INGREDIENTS</th>
                                                                    <th>NUTRITIONAL FACTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Immunity Booster Advanced</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Elderberry Extract – 150 mg</li>
                                                                            <li>Echinacea Extract – 100 mg</li>
                                                                            <li>Vitamin C – 1000 mg</li>
                                                                            <li>Vitamin D3 – 1000 IU (25 mcg)</li>
                                                                            <li>Zinc – 10 mg</li>
                                                                            <li>Citric Acid, Sodium Bicarbonate, Natural Blackberry Flavor, Sucralose</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 3.8 kcal</li>
                                                                            <li>Sugar: 0 g</li>
                                                                            <li>Sodium: 160 mg</li>
                                                                            <li>Elderberry Polyphenols: ~20 mg</li>
                                                                            <li>Vitamin C: 1000 mg (1250% RDA)</li>
                                                                            <li>Zinc: 10 mg (91% RDA)</li>
                                                                            <li>Vitamin D3: 25 mcg (125% RDA)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Energy Booster (B-Complex + Ginseng)</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Ginseng Extract – 100 mg</li>
                                                                            <li>Vitamin B1 – 1.2 mg</li>
                                                                            <li>Vitamin B2 – 1.5 mg</li>
                                                                            <li>Vitamin B6 – 2 mg</li>
                                                                            <li>Vitamin B12 – 5 mcg</li>
                                                                            <li>Niacinamide – 15 mg</li>
                                                                            <li>Folic Acid – 400 mcg</li>
                                                                            <li>Citric Acid, Sodium Bicarbonate, Lemon-Ginger Flavor, Stevia</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 4.5 kcal</li>
                                                                            <li>Carbohydrates: 0.2 g</li>
                                                                            <li>Vitamin B-complex: 100–300% RDA</li>
                                                                            <li>Ginseng: 100 mg (Standardized)</li>
                                                                            <li>Sodium: 140 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SPORTS & FITNESS EFFERVESCENT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sportsEffervescent">
                                                    <i class="bi bi-capsule me-2"></i>SPORTS & FITNESS EFFERVESCENT
                                                </button>
                                            </h2>
                                            <div id="sportsEffervescent" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>INGREDIENTS</th>
                                                                    <th>NUTRITIONAL FACTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Pre-Workout Spark</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>L-Citrulline Malate – 1000 mg</li>
                                                                            <li>Beta-Alanine – 500 mg</li>
                                                                            <li>BCAA Blend (2:1:1) – 750 mg</li>
                                                                            <li>Caffeine – 100 mg</li>
                                                                            <li>Vitamin B6 – 1.5 mg</li>
                                                                            <li>Niacin – 10 mg</li>
                                                                            <li>Citric Acid, Sodium Bicarbonate, Cola Flavor, Sucralose</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 6 kcal</li>
                                                                            <li>Protein (Amino Acids): 0.8 g</li>
                                                                            <li>Caffeine: 100 mg</li>
                                                                            <li>Sodium: 180 mg</li>
                                                                            <li>Beta-Alanine: 500 mg</li>
                                                                            <li>Vitamin B6: 1.5 mg (75% RDA)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- WELLNESS & BEAUTY EFFERVESCENT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#wellnessEffervescent">
                                                    <i class="bi bi-capsule me-2"></i>WELLNESS & BEAUTY EFFERVESCENT
                                                </button>
                                            </h2>
                                            <div id="wellnessEffervescent" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>INGREDIENTS</th>
                                                                    <th>NUTRITIONAL FACTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>K-Glow Effervescent</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Reduced Glutathione (Setria®) – 500 mg</li>
                                                                            <li>Vitamin C (Ascorbic Acid) – 500 mg</li>
                                                                            <li>Hyaluronic Acid (Low Molecular Weight) – 50 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 7 kcal</li>
                                                                            <li>Carbohydrates: 1.2 g</li>
                                                                            <li>Sugars: 0 g</li>
                                                                            <li>Protein: 0.1 g</li>
                                                                            <li>Fat: 0 g</li>
                                                                            <li>Sodium: 35 mg</li>
                                                                            <li>Potassium: 40 mg</li>
                                                                            <li>Glutathione: 500 mg</li>
                                                                            <li>Vitamin C: 500 mg</li>
                                                                            <li>Hyaluronic Acid: 50 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Beauty Biotics</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Lactobacillus Rhamnosus – 1 Billion CFU</li>
                                                                            <li>Hydrolyzed Collagen – 1000 mg</li>
                                                                            <li>Biotin – 30 mcg</li>
                                                                            <li>Citric Acid, Strawberry Flavor, Natural Color, Stevia</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 7 kcal</li>
                                                                            <li>Carbohydrates: 1.5 g</li>
                                                                            <li>Protein: 1.2 g</li>
                                                                            <li>Fat: 0 g</li>
                                                                            <li>Sodium: 30 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SPECIALTY EFFERVESCENT -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#specialtyEffervescent">
                                                    <i class="bi bi-capsule me-2"></i>SPECIALTY EFFERVESCENT
                                                </button>
                                            </h2>
                                            <div id="specialtyEffervescent" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                    <th>INGREDIENTS</th>
                                                                    <th>NUTRITIONAL FACTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>K-Digest</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Fermented Enzyme Blend – 100 mg</li>
                                                                            <li>Ginger Extract – 50 mg</li>
                                                                            <li>Prebiotics (Inulin) – 500 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 6 kcal</li>
                                                                            <li>Carbohydrates: 1.2 g</li>
                                                                            <li>Protein: 0 g</li>
                                                                            <li>Fat: 0 g</li>
                                                                            <li>Sodium: 50 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Hanbang Harmony</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Ginseng Extract – 100 mg</li>
                                                                            <li>Schisandra Berry Extract – 80 mg</li>
                                                                            <li>Reishi Mushroom Extract – 70 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Energy: 5 kcal</li>
                                                                            <li>Carbohydrates: 1 g</li>
                                                                            <li>Protein: 0 g</li>
                                                                            <li>Fat: 0 g</li>
                                                                            <li>Sodium: 45 mg</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default EffervescentTablets; 